<div class="horizontal justify-content-center justify-content-sm-between">
  <h4>Attachments</h4>
  <input
    #fileInput
    (change)="onFileInputChanged(fileInput)"
    type="file"
    class="form-control"
    id="import-upload"
    multiple
    accept="*"
    style="display: none"
  />

  <div ngbDropdown class="btn-group mb-2" placement="bottom-end">
    <button
      type="button"
      id="disposal-dropdown"
      class="btn btn-outline overflow-hidden"
      ngbDropdownToggle
      authorizeEnable
      [authorizeRegister]="RegisterPermission.UpdateAsset"
      [authorizeFeature]="Feature.Attachments"
    >
      <i-lucide name="plus"></i-lucide>
      Add Attachment
    </button>
    <div ngbDropdownMenu aria-labelledby="disposal-dropdown">
      <button
        ngbDropdownItem
        authorizeEnable
        [authorizeRegister]="RegisterPermission.UpdateAsset"
        type="button"
        (click)="fileInput.click()"
      >
        <i-lucide name="file"></i-lucide>
        Choose Files
      </button>

      <button
        ngbDropdownItem
        authorizeEnable
        [authorizeRegister]="RegisterPermission.UpdateAsset"
        type="button"
        (click)="createLinkAttachment()"
      >
        <i-lucide name="link"></i-lucide>
        Add Link
      </button>
    </div>
  </div>
</div>
@if (attachments != null && !uploading) {
  @if (attachments.length > 0) {
    <ul class="list-group mb-1 pb-2">
      @for (attachment of attachments; track attachment; let i = $index) {
        <li class="list-group-item p-2">
          <div class="row justify-content-between">
            <div class="col-5">
              @if (!attachment.isExternalLink) {
                <a
                  class="link text-start ps-0"
                  (click)="downloadAttachment(attachment)"
                >
                  {{ attachment.fileName }}
                </a>
              }
              @if (attachment.isExternalLink) {
                <a
                  class="link text-start ps-0"
                  (click)="openLink(attachment.externalStorageLink)"
                >
                  {{ attachment.fileName }}
                </a>
              }
            </div>
            <div class="col-5">
              <div class="mt-1 text-body-secondary source">
                {{
                  attachment.isExternalLink ? 'Link added by' : 'Uploaded by'
                }}
                {{ attachment.createdByUserFullName }} at
                <time [attr.datetime]="attachment.created">{{
                  attachment.created | amFromUtc | amLocal | amDateFormat: 'LLL'
                }}</time>
              </div>
              @if (attachment.modifiedByUserFullName) {
                <div class="mt-1 text-body-secondary source">
                  Last modified by {{ attachment.modifiedByUserFullName }} at
                  <time [attr.datetime]="attachment.modified">{{
                    attachment.modified
                      | amFromUtc
                      | amLocal
                      | amDateFormat: 'LLL'
                  }}</time>
                </div>
              }
            </div>
            <div class="col-2 col-action">
              <div>
                @if (attachment.isExternalLink) {
                  <button
                    type="button"
                    class="btn btn-outline"
                    authorizeEnable
                    [authorizeRegister]="RegisterPermission.UpdateAsset"
                    (click)="editAttachment(attachment)"
                  >
                    <i-lucide name="edit2"></i-lucide>
                  </button>
                }
                <button
                  type="button"
                  class="btn btn-outline ms-2"
                  authorizeEnable
                  [authorizeRegister]="RegisterPermission.UpdateAsset"
                  (click)="deleteAttachment(attachment)"
                >
                  <i-lucide name="trash2"></i-lucide>
                </button>
              </div>
            </div>
          </div>
        </li>
      }
    </ul>
  }
} @else {
  <app-loading></app-loading>
}
